import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-content/fleche-passer-au-suivant-blanc.png'
import _imports_1 from '@/assets/new-content/fleche-clic-orange.png'
import _imports_2 from '@/assets/new-content/fleche-grise.png'
import _imports_3 from '@/assets/new-content/outils-excel.png'
import _imports_4 from '@/assets/new-content/photos.png'
import _imports_5 from '@/assets/new-content/loupe-blanc.png'
import _imports_6 from '@/assets/new-content/check-blanc.png'
import _imports_7 from '@/assets/new-content/marque-de-croix-blanc.png'
import _imports_8 from '@/assets/new-content/fleche-envoyer-blanc.png'


const _withScopeId = n => (_pushScopeId("data-v-da9b857e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main vld-parent" }
const _hoisted_2 = { class: "step-container" }
const _hoisted_3 = {
  key: 0,
  class: "modal-container"
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1")
], -1))
const _hoisted_6 = { class: "heading" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "from-container" }
const _hoisted_9 = { class: "input-container" }
const _hoisted_10 = { class: "input-field" }
const _hoisted_11 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "input-container" }
const _hoisted_14 = { class: "input-field" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "modal-footer" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 1,
  class: "modal-container"
}
const _hoisted_22 = {
  id: "modal_2_Header",
  class: "modal-header"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createElementVNode("span", null, "2")
], -1))
const _hoisted_24 = { class: "heading" }
const _hoisted_25 = { class: "modal-body" }
const _hoisted_26 = { class: "option-container" }
const _hoisted_27 = { class: "text-container" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "option-container disabled" }
const _hoisted_31 = { class: "text-container" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-disabled button-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_33 = { class: "modal-footer" }
const _hoisted_34 = {
  key: 2,
  class: "modal-container"
}
const _hoisted_35 = { class: "modal-header" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createElementVNode("span", null, "3")
], -1))
const _hoisted_37 = { class: "heading" }
const _hoisted_38 = { class: "modal-body" }
const _hoisted_39 = {
  for: "ExcelFile",
  class: "newContentStep3 option-container"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1))
const _hoisted_41 = {
  for: "ArchiveFile",
  class: "newContentStep3 option-container"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "modal-footer" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "step-container" }
const _hoisted_48 = {
  key: 0,
  class: "modal-lg-container modal-container"
}
const _hoisted_49 = {
  class: "modal-header",
  id: "modal_4_Header"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createElementVNode("span", null, "4")
], -1))
const _hoisted_51 = { class: "heading" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
], -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  class: "modal-body",
  id: "modal_4_Body"
}
const _hoisted_55 = { class: "text-container" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  key: 0,
  class: "status-container"
}
const _hoisted_58 = {
  key: 0,
  class: "to-verify option-container"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_5 })
], -1))
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "alert-container" }
const _hoisted_62 = {
  key: 1,
  class: "verified option-container"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_6 })
], -1))
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "alert-container" }
const _hoisted_66 = {
  class: "modal-footer",
  id: "modal_4_Footer"
}
const _hoisted_67 = { class: "buttons" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_7 })
], -1))
const _hoisted_69 = ["value"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_8 })
], -1))
const _hoisted_71 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorModal = _resolveComponent("ErrorModal")!
  const _component_ReadDataModal = _resolveComponent("ReadDataModal")!
  const _component_DuplicateDataModal = _resolveComponent("DuplicateDataModal")!
  const _component_Header = _resolveComponent("Header")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.errorModalOpen)
      ? (_openBlock(), _createBlock(_component_ErrorModal, {
          key: 0,
          messages: $setup.errorMessage || [$setup.t('generic.error')],
          onClose: $setup.CloseErrorModal
        }, null, 8, ["messages", "onClose"]))
      : _createCommentVNode("", true),
    ($setup.readDataModalOpen)
      ? (_openBlock(), _createBlock(_component_ReadDataModal, {
          key: 1,
          Title: $setup.GetCurrentActivityName(),
          Data: $setup.readData,
          onClose: $setup.CloseReadDataModal
        }, null, 8, ["Title", "Data", "onClose"]))
      : _createCommentVNode("", true),
    ($setup.duplicateDataModalOpen)
      ? (_openBlock(), _createBlock(_component_DuplicateDataModal, {
          key: 2,
          Title: $setup.GetCurrentActivityName(),
          Data: $setup.duplicateData,
          onClose: $setup.CloseDuplicateDataModal,
          onSubmit: $setup.SubmitDuplicateDataModal,
          selectedData: $setup.keepDuplicateDataIndex
        }, null, 8, ["Title", "Data", "onClose", "onSubmit", "selectedData"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Header, {
      title: $setup.t('components.sidebar.menu.newContent'),
      onBack: $setup.GoBack
    }, null, 8, ["title", "onBack"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: $setup.isLoading,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.isLoading) = $event)),
        "can-cancel": false,
        "is-full-page": true
      }, null, 8, ["active"]),
      _createElementVNode("div", _hoisted_2, [
        ($setup.modals.includes($setup.domainActivityModal))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('pages.dashboard.newContent.chooseActivity')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("select", {
                        id: "Domains",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.stepFormData.DomainId) = $event)),
                        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.HandleDomainsAndActivity && $setup.HandleDomainsAndActivity(...args)))
                      }, [
                        _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t('pages.dashboard.newContent.filterByDomain')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.domains, (domain) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: domain.dom_id,
                            value: domain.dom_id
                          }, _toDisplayString(domain.dom_label), 9, _hoisted_12))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, $setup.stepFormData.DomainId]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.stepFormData.ActivityId) = $event)),
                        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.HandleDomainsAndActivity && $setup.HandleDomainsAndActivity(...args))),
                        disabled: !$setup.stepFormData.DomainId
                      }, [
                        _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t('pages.dashboard.newContent.selectActivity')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activities, (activity) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: activity.act_id,
                            value: activity.act_id
                          }, _toDisplayString(activity.act_label), 9, _hoisted_17))
                        }), 128))
                      ], 40, _hoisted_15), [
                        [_vModelSelect, $setup.stepFormData.ActivityId]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: "button-container",
                  style: _normalizeStyle({
                            display: $setup.isEnableFirstStepContinue() ? 'flex' : 'none',
                        }),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.isEnableFirstStepContinue() ? $setup.AddModal($setup.methodModal) : null))
                }, [
                  _hoisted_19,
                  _createElementVNode("input", {
                    type: "button",
                    value: $setup.t('generic.continue')
                  }, null, 8, _hoisted_20)
                ], 4)
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.modals.includes($setup.methodModal))
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('pages.dashboard.newContent.chooseMethod')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('pages.dashboard.newContent.parameterizedFile')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('pages.dashboard.newContent.excelAndPictures')), 1)
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.AddModal($setup.filesModal))),
                    class: "button-container"
                  }, _hoisted_29)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.$t('pages.dashboard.newContent.directIntegration')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('pages.dashboard.newContent.dedicatedInterface')), 1)
                  ]),
                  _hoisted_32
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('pages.dashboard.newContent.chooseMethodFooter')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.modals.includes($setup.filesModal))
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('pages.dashboard.newContent.importFiles')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("label", _hoisted_39, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["chose-container", $setup.excelFileError ? 'chose-container-error' : null])
                  }, [
                    _hoisted_40,
                    _createElementVNode("span", null, _toDisplayString(typeof $setup.stepFormData.ExcelFile === 'string'
                                    ? $setup.stepFormData.ExcelFile
                                    : $setup.stepFormData.ExcelFile.name), 1),
                    _createElementVNode("input", {
                      ref: "ExcelInputFiled",
                      id: "ExcelFile",
                      type: "file",
                      accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => {if ($setup.ExcelInputFiled) $setup.ExcelInputFiled.value = '';}),
                      onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.HandleFileUploads && $setup.HandleFileUploads(...args)))
                    }, null, 544)
                  ], 2)
                ]),
                _createElementVNode("label", _hoisted_41, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["chose-container", {
                                'input-disabled': !$setup.archiveRequire,
                                'chose-container-error': $setup.archiveFileError,
                            }])
                  }, [
                    _hoisted_42,
                    _createElementVNode("span", null, _toDisplayString(typeof $setup.stepFormData.ArchiveFile === 'string'
                                    ? $setup.stepFormData.ArchiveFile
                                    : $setup.stepFormData.ArchiveFile.name), 1),
                    _createElementVNode("input", {
                      ref: "ArchiveInputFiled",
                      id: "ArchiveFile",
                      type: "file",
                      accept: "application/zip",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => {if ($setup.ArchiveInputFiled) $setup.ArchiveInputFiled.value = '';}),
                      onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.HandleFileUploads && $setup.HandleFileUploads(...args))),
                      disabled: !$setup.archiveRequire
                    }, null, 40, _hoisted_43)
                  ], 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", {
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.SubmitFileToValidate && $setup.SubmitFileToValidate(...args))),
                  class: "button-container",
                  style: _normalizeStyle({
                            display: $setup.isEnableThirdStepContinue() ? 'flex' : 'none',
                        })
                }, [
                  _hoisted_45,
                  _createElementVNode("input", {
                    type: "button",
                    value: $setup.t('generic.continue'),
                    style: _normalizeStyle({
                                cursor: $setup.isEnableThirdStepContinue() ? 'pointer' : 'default',
                            })
                  }, null, 12, _hoisted_46)
                ], 4)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_47, [
        ($setup.modals.includes($setup.validationModal))
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('pages.dashboard.newContent.contentValidation')), 1)
                ]),
                _createElementVNode("div", {
                  class: "search-container",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.OpenReadDataModal()))
                }, _hoisted_53)
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('pages.dashboard.newContent.entryCount', {
                                    dataCount: $setup.dataCountToSave,
                                })), 1),
                  ($setup.duplicateData.headers.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(_ctx.$t('pages.dashboard.newContent.paraText')), 1))
                    : _createCommentVNode("", true)
                ]),
                ($setup.duplicateData.headers.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      (!$setup.duplicatesChecked)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _createElementVNode("div", {
                              class: "blue-btn button-container",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.OpenDuplicateDataModal()))
                            }, [
                              _hoisted_59,
                              _createElementVNode("input", {
                                type: "button",
                                value: $setup.t('pages.dashboard.newContent.toVerify')
                              }, null, 8, _hoisted_60)
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('generic.attention')) + " :", 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t('pages.dashboard.newContent.duplicateData', {
                                            duplicateDataCount: $setup.duplicateData.values.length,
                                        })), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createElementVNode("div", {
                              class: "button-container",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.OpenDuplicateDataModal()))
                            }, [
                              _hoisted_63,
                              _createElementVNode("input", {
                                type: "button",
                                value: $setup.t('generic.verified')
                              }, null, 8, _hoisted_64)
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('generic.done')) + " :", 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t('pages.dashboard.newContent.choseDuplicates', {
                                            choseDataCount: $setup.keepDuplicateDataIndex.length,
                                            duplicateDataCount: $setup.duplicateData.values.length,
                                        })), 1)
                            ])
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", {
                    onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.CancelImport())),
                    class: "button-container",
                    id: "cancelButton"
                  }, [
                    _hoisted_68,
                    _createElementVNode("input", {
                      type: "button",
                      value: $setup.t('generic.cancel')
                    }, null, 8, _hoisted_69)
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => ($setup.SubmitToImport && $setup.SubmitToImport(...args))),
                    class: "button-container",
                    id: "lastButton"
                  }, [
                    _hoisted_70,
                    _createElementVNode("input", {
                      type: "button",
                      value: $setup.t('generic.submit')
                    }, null, 8, _hoisted_71)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}